import {Component, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {HelpDialogComponent} from '../../help-dialog/help-dialog.component';
import {Router} from '@angular/router';

@Component({
  selector: 'app-zoom-help',
  templateUrl: './zoom-help.component.html',
  styleUrls: ['./zoom-help.component.scss']
})
export class ZoomHelpComponent implements OnInit {

  text = 'Drag the mouse by drawing a rectangle over the area of the graph you want to zoom in on.';
  textMap = 'Click on + and - icon or move the mouse wheel forward and backward to increase or decrease the zoom respectively ';
  mapChart!: boolean;

  constructor(private dialog: MatDialog,
              private router: Router) {
  }

  ngOnInit(): void {
    this.mapChart = this.router.url.includes('/systems-in-country')
      || this.router.url.includes('/visible-fee')
      || this.router.url.includes('/re-use-targets')
      || this.router.url.includes('/weee-treatment-standard-mandatory');
  }

  openInfoDialog(): void {
    this.dialog.open(HelpDialogComponent, {
      data: {
        title: 'Chart Zoom',
        text: this.mapChart ? this.textMap : this.text
      }, maxWidth: 600
    });
  }

}
